export default __webpack_public_path__ + "static/media/Download.1f0a8fb8.svg";